import Vue from 'vue'

export default {
  setFleets: (state, value) => {
    state.fleets = value
  },
  addFleet: (state, value) => {
    const exists = state.fleets.some(info => {
      return info.Id === value.Id
    })
    if (!exists) {
      state.fleets.push(value)
    }
  },
  setFleet: (state, value) => {
    if (value && value.Zones.length) {
      value.Zones = value.Zones.slice(1, -1).split('|')
    }
    state.fleet = value
  },
  setFleetInFleetsArray: (state, payload) => {
    const existingFleet = state.fleets.find(fleet => {
      return fleet.Id === payload.ID
    })
    Object.assign(existingFleet, payload)
  },
  setCurrentFleetId: (state, value) => {
    state.currentFleetId = value
  },
  setAvailabilityInfo: (state, value) => {
    state.availabilityInfo = value
  },
  /**
   * Sets specified key value on fleet Object
   * @param {Object} object - { key: 'Name', value: 'Test Name Value' }
   */
  setFleetValue: (state, data) => {
    Vue.set(state.fleet, data.key, data.value)
  },
  addUserToFleet: (state, user) => {
    const fleetUserIndex = state.fleet.Users.findIndex(
      fleetUser => fleetUser.ID === user.ID
    )
    if (fleetUserIndex === -1) {
      state.fleet.Users.push(user)
    }
  },
  removeFleetUser: (state, payload) => {
    const fleetUserIndex = state.fleet.Users.findIndex(
      user => user.ID === payload.ID
    )
    state.fleet.Users.splice(fleetUserIndex, 1)
  },
  updateFleetUser: (state, payload) => {
    const fleetUserIndex = state.fleet.Users.findIndex(
      user => user.ID === payload.ID
    )
    state.fleet.Users[fleetUserIndex] = payload
  },
  setFleetManagerRestrictedToFleetUserId: (state, data) => {
    const managerIndex = state.fleet.Managers.findIndex(
      manager => manager.ID === data.id
    )
    Vue.set(state.fleet.Managers[managerIndex], data.key, data.value)
  },
  removeManagerFromFleetManagersArray: (state, data) => {
    const fleetManagerIndex = state.fleet.Managers.findIndex(
      user => user.OwnerId === data.OwnerId
    )
    state.fleet.Managers.splice(fleetManagerIndex, 1)
  },
  setFleetsLoaded: (state, value) => {
    state.fleetsLoaded = value
  },
  setNextAvailablePage: (state, value) => {
    state.nextAvailablePage = value
  },
  setCurrentPage: (state, value) => {
    state.currentPage = value
  },
  setPageSize: (state, value) => {
    state.pageSize = value
  }
}
